$bog_builderui_dialog $bog_builderui_div
	showed? false
	title \
	text \
	content /
	confirm_title \Confirm
	close? null
	confirm? null
	attr *
		bog_builderui_dialog_showed <= showed?
	sub /
		<= Backdrop $mol_view
			event *
				click? <=> close? null
		<= Surface $bog_builderui_card sub /
			<= Surface_title $mol_view sub /
				<= title
			<= Surface_text $mol_view sub /
				<= text
			<= Surface_content $mol_view sub <= content
			<= Surface_actions $mol_view sub /
				<= Cancel $bog_builderui_button
					title \Cancel
					click? <=> close? null
				<= Confirm $bog_builderui_button
					title <= confirm_title
					click? <=> confirm? null
